if (!customElements.get('product-conditions')) {
  customElements.define(
    'product-conditions',
    class ProductConditions extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const clickedElement = e.target.closest('[data-target]');
          if (!clickedElement) return
          const targetPanel = clickedElement.dataset.target;
          this.swapPanels(targetPanel);
        });
        this.addEventListener('change', (e) => {
          const selectElement = e.target.closest('[data-condition-select]');
          if (!selectElement) return
          const targetPanel = selectElement.value;
          this.swapPanels(targetPanel);
        })
      }
  
      swapPanels(targetPanel) {
        [...this.querySelectorAll('[data-target]')].forEach(btn => {
          btn.dataset.target === targetPanel ? btn.classList.add('active') : btn.classList.remove('active'); 
        });
        [...this.querySelectorAll('[data-condition]')].forEach(panel => {
          panel.dataset.condition === targetPanel ? panel.classList.remove('hidden') : panel.classList.add('hidden'); 
          if (panel.dataset.condition === targetPanel) { 
            const headerOffset = document.querySelector('site-header').offsetHeight;
            const elementPosition = panel.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.scrollY - headerOffset;
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
          }
        });
      }
    }
  );
}